export default __webpack_public_path__ + "static/media/background-portal-2.2371aba7.svg";